exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style__InformationFormsContainer___1fzzI {\n  margin-top: 40px; }\n\n.style__InformationFormsWrapper___2kx21 p {\n  margin-right: auto;\n  font-family: Roboto;\n  font-size: 18px;\n  font-weight: normal;\n  font-style: normal;\n  text-align: left;\n  color: #333333; }\n\n.style__FormStyle___377CW {\n  border-radius: 10px;\n  background-color: #f0f0f0;\n  border: solid 1px #707070;\n  padding: 15px 20px 15px 20px;\n  font-family: Roboto;\n  font-size: 16px;\n  font-weight: 300;\n  font-style: normal;\n  font-stretch: normal; }\n", ""]);

// exports
exports.locals = {
	"InformationFormsContainer": "style__InformationFormsContainer___1fzzI",
	"InformationFormsWrapper": "style__InformationFormsWrapper___2kx21",
	"FormStyle": "style__FormStyle___377CW"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/component/Forms/SlideInput/style.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/component/Forms/SlideInput/style.css
// module chunks = 0